import type { PersistQueryClientOptions, Persister } from '@tanstack/react-query-persist-client';

import { version } from '../package.json';

/**
 * A versão do app, a do `package.json`. É o `buster` do cache de consultas persistido: uma versão nova descarta, na
 * primeira abertura, o cache gravado pela anterior, em vez de reidratá-lo sob as mesmas chaves (a virada de E11 troca
 * a API de endereço, decisão 9).
 */
export const APP_VERSION: string = version;

/** O cache sobrevive a um dia com o app fechado, como o `gcTime` das consultas. */
export const PERSISTED_CACHE_MAX_AGE_MS = 24 * 60 * 60 * 1_000;

export type QueryPersistOptions = Omit<PersistQueryClientOptions, 'queryClient'>;

export function queryPersistOptions(persister: Persister): QueryPersistOptions {
  return {
    persister,
    maxAge: PERSISTED_CACHE_MAX_AGE_MS,
    buster: APP_VERSION,
    dehydrateOptions: {
      shouldDehydrateQuery: (query) =>
        query.state.status === 'success' &&
        // Cursor pagination não roda bem reidratada porque o cursor pode
        // estar inválido. Persistimos só queries idempotentes.
        !query.queryKey.includes('infinite') &&
        // A chave do convite carrega o token do e-mail: ele não fica gravado no aparelho
        // depois do aceite, que o consome (E9).
        !query.queryKey.includes('invitations') &&
        // O arquivo de um documento (E14) é um blob, que não vira JSON, e não fica no
        // aparelho depois que o visualizador fecha.
        !query.queryKey.includes('file'),
    },
  };
}
